export const NAME = 'DeclinedConditionsModal';
export const TITLE = 'Disability insurance is not available for applicants with';
export const CONTENT =
  "Unfortunately, disability insurers will decline coverage when there's been a diagnosis for";
export const SORRY_NOTE = "We're sorry we can't be more helpful with your request.";

export enum DeclinedConditions {
  MS = 'multiple sclerosis',
  Alzheimers = "Alzheimer's disease",
}
